import { render, staticRenderFns } from "./loveComponent.vue?vue&type=template&id=ab47489c&"
import script from "./loveComponent.vue?vue&type=script&lang=js&"
export * from "./loveComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports